/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ISymbolData from '../../ISymbolData';
import StreakTrackerFilterBase from './StreakTrackerFilterBase';

const {ccclass, property} = cc._decorator;

@ccclass
export default class SingleSymbolPerReelFilter extends StreakTrackerFilterBase
{
    public Filter = (symbols: ISymbolData[]): ISymbolData[] =>
    {
        let symbolMap: Map<string, ISymbolData> = new Map<string, ISymbolData>();

        for (let symbol of symbols)
        {
            // Create unique key based on unique criteria.
            let key: string = symbol.SymbolId + symbol.ReelIndex;

            // See if exists.
            let foundSymbol: ISymbolData = symbolMap.get(key);

            // Always input first entry.
            if (!foundSymbol)
            {
                symbolMap.set(key, symbol);
            }
            else
            {
                // Is the saved symbol at a higher position? Only first entry kept.
                if (foundSymbol.OffSet > symbol.OffSet)
                {
                    symbolMap.set(key, symbol);
                }
            }
        }

        // Back to array with ye.
        let validSymbols: ISymbolData[] = [];
        symbolMap.forEach(x => validSymbols.push(x));

        return validSymbols;
    }
}
